"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IArray = void 0;
var IArray;
(function (IArray) {
    IArray["IFitBuilt"] = "iFitBuilt";
    IArray["IsFreemotion"] = "IsFreemotion";
    IArray["IsManual"] = "IsManual";
    IArray["IsMap"] = "IsMap";
    IArray["IsMatrix"] = "IsMatrix";
    IArray["IsTranslated"] = "IsTranslated";
    IArray["IsVault"] = "IsVault";
    IArray["IsVideo"] = "IsVideo";
    IArray["IsVue"] = "IsVue";
    IArray["OffEquipment"] = "OffEquipment";
    IArray["OffEquipmentQuickTransition"] = "OffEquipmentQuickTransition";
    IArray["PortraitOrientation"] = "PortraitOrientation";
    IArray["UniversalWorkout"] = "UniversalWorkout";
    IArray["WolfFusion"] = "WolfFusion";
})(IArray || (exports.IArray = IArray = {}));
//# sourceMappingURL=array.js.map